<template>
  <div class="cn_page_category" style="display: none">{{ name }}</div>
</template>

<script setup lang="ts">
defineProps({
  name: {
    type: String,
  },
})
</script>
